/*
*
* Script for cookies - you can use it everywhere you need
*
*/

document.addEventListener('DOMContentLoaded', function() {

	const setCookie = (cname, cvalue, exdays) => {
		const d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	};

	const getCookie = (cname) => {
		let name = cname + "=";
		let ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

    if (document.querySelector('.bn-popup')) {
        let popup = document.querySelector('.bn-popup');
        let window = popup.querySelector('.bn-popup__window');
        let close = popup.querySelector('.bn-popup__window--close');
        let btn = popup.querySelector('.bn-popup__window--button');

        const isDailyQuotaEnabled = bn_popup_vars?.is_dpq_enabled || false;

        const handleClose = () => {
            popup.classList.remove('--open');
            if (isDailyQuotaEnabled) {
                const currentValue = parseInt(getCookie("bn-popup-daily") || "0", 10);
                // Set cookie that expires at the end of the day - calculating time (in s) left to the end of the current day
                const now = new Date();
                const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
                const secondsUntilEndOfDay = Math.round((endOfDay.getTime() - now.getTime()) / 1000);
                
                document.cookie = `bn-popup-daily=${currentValue + 1}; max-age=${secondsUntilEndOfDay}; path=/`;
            } else {
                setCookie("bn-popup", 1, 1);
            }
        };


        close.addEventListener('click', handleClose);
        
        popup.addEventListener('click', e => {
            if (!window.contains(e.target)) {
                handleClose();
            }
        });

        if (btn) {
            btn.addEventListener('click', handleClose);
        }
    }

});